import React from "react";

function Personal() {
  return (
    <article className="personal">
      <h2>Personal</h2>
      <p>
        /* (Work in progress...🛠) */
      </p>
      <p>PS: My YT channel is starting soon!</p>
    </article>
  );
}

export default Personal;
